import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 72px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <Typography
        sx={{
          fontSize: 'clamp(8rem, 30vw, 20rem)',
          fontWeight: 700,
          lineHeight: 1,
          userSelect: 'none',
        }}
      >
        404
      </Typography>
      <Typography variant="h6">Sorry about that.</Typography>
      <Typography variant="body1" color="text.secondary">
        It looks like the page you were looking for doesn't exist, or has been moved.
      </Typography>
      <Button component={Link} to="/" variant="contained" sx={{ mt: 2 }}>
        Go home
      </Button>
    </Box>
  );
}
